import school from "../../asserts/images/school.png";
import ramen from "../../asserts/images/ramen.png";
import diversity from "../../asserts/images/diversity.png";
import workbg from "../../asserts/images/workbg.svg";
import "./works.scss";

const Works = () => {
  return (
    <div>
      <img src={workbg} alt="" className="img-box" />
      <div className="row works-box">
        <div className="col-lg-5 col-md-12 works-content">
          <h1 className="works-heading">
            How Pagirndhunn <br /> works
          </h1>
          <p>
            Your contributions go directly toward nourishing lives, supporting
            education, and creating lasting impact. Here’s how we put your
            generosity to work:
          </p>
        </div>
        <div className="col-lg-7 col-md-12">
          <div className="row two-box">
            <div className="col-sm-5 col-xs-12 small-box">
              <h5>Providing Meals</h5>
              <p>
                Every day, we serve 25 homeless people, with plans to increase
                this to 50 in the future.
                <img src={ramen} alt="" className="small-img" />
              </p>
            </div>
            <div className="col-sm-5 col-xs-12 small-box ">
              <h5>Supporting Education</h5>
              <p>
                We help underprivileged students by covering school fees,
                supplies, and other essentials.
                <img src={school} alt="" className="small-img" />
              </p>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-11 col-md-11 full-box ">
              <h5>Building a Better Future</h5>
              <p>
                We are working towards providing food, shelter, and education
                for homeless individuals, creating a long-term impact.
                <img src={diversity} alt="" className="full-img" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Works;
